import React from "react";

const PARTNERS = [
  { label: "Agence du Numérique en Santé (ANS)",
    src: "https://customer-assets.emergentagent.com/job_digital-gateway-14/artifacts/6gl7gqfr_ans.png",
    href: "https://esante.gouv.fr" },
  { label: "CNDA — Centre National de Dépôt et d'Agrément",
    src: "https://customer-assets.emergentagent.com/job_digital-gateway-14/artifacts/tjkfwm6y_cnda.png",
    href: "https://cnda.ameli.fr" },
  { label: "Mon espace santé",
    src: "https://customer-assets.emergentagent.com/job_digital-gateway-14/artifacts/c10226na_images%20%281%29.png",
    href: "https://www.monespacesante.fr" },
  { label: "France 2030",
    src: "https://customer-assets.emergentagent.com/job_digital-gateway-14/artifacts/qtzcryka_FR%202030%20logo%20article%20fond%20blanc.png",
    href: "https://www.france2030.gouv.fr" },
  { label: "Société Francophone de Santé Numérique (SFSN)",
    src: "https://customer-assets.emergentagent.com/job_digital-gateway-14/artifacts/jurge2zf_images.jfif",
    href: "https://sfsante-numerique.fr" },
  { label: "Bpifrance",
    src: "https://customer-assets.emergentagent.com/job_digital-gateway-14/artifacts/dzgrvq4w_images.png",
    href: "https://www.bpifrance.fr" },
  { label: "AXESS — Digital & Business Experts",
    src: "https://customer-assets.emergentagent.com/job_digital-gateway-14/artifacts/bl04onhy_logo.png",
    href: "https://www.axess.fr",
    bigger: true },
  { label: "Ordoclic",
    src: "https://customer-assets.emergentagent.com/job_digital-gateway-14/artifacts/etgyetvj_logo_ordoclic.png",
    href: "https://ordoclic.fr" },
  { label: "Scale'Up by Dev'Up Centre-Val de Loire",
    src: "https://customer-assets.emergentagent.com/job_digital-gateway-14/artifacts/28rakzdz_logo-scaleup.png",
    href: "https://www.devup-centrevaldeloire.fr/scale-up-excellence" },
  { label: "Osmose Solutions",
    src: "https://customer-assets.emergentagent.com/job_digital-gateway-14/artifacts/1ncw1y70_osmose_solutions1_logo.jfif",
    href: "https://www.osmose-it.fr" },
  { label: "Université Catholique de Lille",
    src: "https://customer-assets.emergentagent.com/job_digital-gateway-14/artifacts/kpprujqh_t%C3%A9l%C3%A9chargement%20%281%29.jfif",
    href: "https://www.univ-catholille.fr" },
  { label: "Dev'Up Centre-Val de Loire",
    src: "https://customer-assets.emergentagent.com/job_digital-gateway-14/artifacts/wt6tzqcm_t%C3%A9l%C3%A9chargement%20%281%29.png",
    href: "https://www.devup-centrevaldeloire.fr" },
  { label: "Lexagone — DPO externalisé & RGPD",
    src: "https://customer-assets.emergentagent.com/job_digital-gateway-14/artifacts/fmrj6nob_t%C3%A9l%C3%A9chargement.jfif",
    href: "https://www.lexagone.fr" },
  { label: "CNIL — Commission Nationale Informatique & Libertés",
    src: "https://customer-assets.emergentagent.com/job_digital-gateway-14/artifacts/bmdci9dl_t%C3%A9l%C3%A9chargement.png",
    href: "https://www.cnil.fr" },
  { label: "cybeRéponse Centre-Val de Loire",
    src: "https://customer-assets.emergentagent.com/job_digital-gateway-14/artifacts/hik39iw1_logo-cyber-reponse.png",
    href: "https://cybereponse.fr" },
  { label: "iVoirNet",
    src: "https://customer-assets.emergentagent.com/job_digital-gateway-14/artifacts/4xhk0w33_1776963867415-6eh7sih%20%281%29.png",
    href: "https://www.ivoirnet.com" },
];

export default function PartnersBanner() {
  const loop = [...PARTNERS, ...PARTNERS];
  return (
    <section className="relative py-20 lg:py-24" style={{ background: "#F8FAFC" }} data-testid="section-partners">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2" style={{ fontSize: 11, color: "#4FC3F7", letterSpacing: "0.18em", textTransform: "uppercase", fontWeight: 600 }}>
            <span style={{ height: 1, width: 28, background: "#4FC3F7" }} />
            Écosystème &amp; partenaires
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl leading-tight mt-4" style={{ color: "#0F2B5B", fontWeight: 600, letterSpacing: "-0.018em" }}>
            Ils nous font confiance.
          </h2>
          <p className="mt-5 mx-auto max-w-2xl text-[14.5px] lg:text-[15.5px] leading-relaxed" style={{ color: "#64748B" }}>
            Institutions, partenaires industriels et acteurs de la santé numérique qui collaborent
            avec MetaConnect sur le terrain.
          </p>
        </div>

        <div className="partners-marquee-wrapper relative overflow-hidden py-7 lg:py-8"
             style={{ background: "#ffffff", border: "0.5px solid #E8EDF5", borderRadius: 16, maskImage: "linear-gradient(90deg, transparent 0, #000 5%, #000 95%, transparent 100%)",
                      WebkitMaskImage: "linear-gradient(90deg, transparent 0, #000 5%, #000 95%, transparent 100%)" }}>
          <div className="partners-marquee-track flex items-center gap-4 lg:gap-5 w-max">
            {loop.map((p, i) => (
              <a key={`${p.label}-${i}`}
                 href={p.href}
                 target="_blank"
                 rel="noopener noreferrer nofollow"
                 title={p.label}
                 aria-label={p.label}
                 className={`shrink-0 h-[100px] grid place-items-center rounded-xl hover:-translate-y-0.5 transition-all duration-300 ${p.bigger ? "w-[300px] px-4" : "w-[220px] px-6"}`}
                 style={{ background: "#ffffff", border: "0.5px solid #E8EDF5", boxShadow: "0 4px 12px -6px rgba(15,43,91,0.10)" }}
                 data-testid={`partner-logo-${i}`}>
                <img
                  src={p.src}
                  alt={`Logo ${p.label}`}
                  loading="lazy"
                  className={`w-auto object-contain ${p.bigger ? "max-h-[78px] max-w-full" : "max-h-[56px]"}`}
                  draggable={false}
                />
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
